import { render, staticRenderFns } from "./PlayerRegistrationFormPlayerDetails.vue?vue&type=template&id=69f3180e&scoped=true&"
import script from "./PlayerRegistrationFormPlayerDetails.vue?vue&type=script&lang=js&"
export * from "./PlayerRegistrationFormPlayerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69f3180e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VForm})
